module.exports = __webpack_public_path__ + "img/2_14.cff29bff.png";